import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthTokenlessBaseService } from './auth-tokenless-base.service';
import { LoginResponse } from '../helper/dto/login-response.dto';
import { PublicSettingDto } from '../helper/dto/public-settings.dto';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends AuthTokenlessBaseService {
    login(username: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/login'),
            {
                username: username,
                password: password
            },
            {
                withCredentials: true
            }
        );
    }

    tokenBySession(): Observable<LoginResponse> {
        return this.http.get<LoginResponse>(this.apiUrl('v1/auth/token-by-session'), {
            withCredentials: true
        });
    }

    renewToken(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/renew'),
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + token
                },
                withCredentials: true
            }
        );
    }

    createActorToken(userId: string, token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/actor-token'),
            {
                userId
            },
            {
                headers: {
                    Authorization: 'Bearer ' + token
                },
                withCredentials: true
            }
        );
    }

    revokeActorToken(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/actor-token/revoke'),
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + token
                },
                withCredentials: true
            }
        );
    }

    twoFactorLogin(name: string, code: string, token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/two-factor'),
            {
                name,
                code
            },
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        );
    }

    verify(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/verify'), {
            token
        });
    }

    lock(token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/lock'), {
            token
        });
    }

    resetRequest(mail: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/reset-request'), {
            mail
        });
    }

    reset(token: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.apiUrl('v1/auth/reset'), {
            token,
            password
        });
    }

    getThemeData(): Observable<PublicSettingDto[]> {
        return this.http.get<PublicSettingDto[]>(this.apiUrl('v1/setting/public/theme'));
    }

    getOIDCData(): Observable<PublicSettingDto[]> {
        return this.http.get<PublicSettingDto[]>(this.apiUrl('v1/setting/public/oidc'));
    }

    logout(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
            this.apiUrl('v1/auth/logout'),
            {},
            {
                withCredentials: true
            }
        );
    }
}
